<template>
  <el-dialog title="录入密码"
             :visible.sync="showModal"
             @close="handleCancel"
             append-to-body
             width="40%">
    <el-row>
      <el-row class="mb-15">
        <el-button v-has="'/med_passwd/add'"
                   :disabled="tableData.length > 2"
                   type="primary"
                   @click="handleInput">录入密码</el-button>
      </el-row>
      <el-card shadow="none">
        <el-table max-height="575"
                  ref="multipleTable"
                  :data="tableData">
          <el-table-column label="序号"
                           type="index"
                           width="60"></el-table-column>
          <el-table-column label="密码"
                           prop="svalue"
                           min-width="100"
                           :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column fixed="right"
                           label="操作"
                           width="80">
            <template slot-scope="scope">
              <el-button v-has="'/med_passwd/del'"
                         size="mini"
                         type="danger"
                         @click="handleDelete(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-card>
      <el-dialog title="录入密码"
                 :visible.sync="showInput"
                 @close="cancelInput"
                 append-to-body
                 width="40%">
        <el-col :span="24">
          <el-form :model="manInfo"
                   :rules="manRules"
                   ref="manForm"
                   label-width="80px"
                   class="man-form">
            <el-form-item label="密码："
                          prop="svalue">
              <el-select v-model="manInfo.svalue"
                         placeholder="请选择">
                <el-option v-for="item in passList"
                           :key="item"
                           :label="item"
                           :value="item">
                </el-option>
              </el-select>
              <!-- <el-input type="password"
                        v-model.number.trim="manInfo.svalue"
                        placeholder="请输入密码"></el-input> -->
            </el-form-item>
          </el-form>
        </el-col>
        <span slot="footer"
              class="dialog-footer">
          <el-button @click="cancelInput">取 消</el-button>
          <el-button v-has="'/med_passwd/add'"
                     type="primary"
                     @click="confirmInput('manForm')">
            确 定
          </el-button>
        </span>
      </el-dialog>
    </el-row>
    <span slot="footer"
          class="dialog-footer">
      <el-button type="primary"
                 @click="handleCancel">关 闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
import fetch from '@/common/api'
import utils from '@/common/utils'
export default {
  props: {
    isShow: {
      type: Boolean
    },
    data: {
      type: Object
    }
  },
  data() {
    // var validatePass = (rule, value, callback) => {
    //   if ((value + '').length < 8) {
    //     callback(new Error('请输入8位数字密码'))
    //   }
    //   callback()
    // }
    return {
      showModal: this.isShow,
      manInfo: {
        svalue: ''
      },
      manRules: {
        svalue: [
          { required: true, message: '请选择密码' }
          // { validator: validatePass, trigger: 'blur' },
          // { type: 'number', message: '密码必须为数字值' }
        ]
      },
      showInput: false,
      tableData: [],
      passList: [],
      randomNum: ''
    }
  },
  created() {
    this.getInfo()
  },
  methods: {
    // 获取编辑信息
    getInfo() {
      fetch.getPassList({ person_id: this.data.id }).then((data) => {
        data.procData(
          data.res,
          (data) => {
            this.tableData = data.list.map((item) => {
              item.svalue = utils.vaguePass(item.svalue)
              return item
            })
          },
          (err) => {
            this.$message.error(err)
          }
        )
      })
    },
    // 读取介质
    getMediumInfo() {
      this.randomNum = this.getRandomNum()
      fetch
        .getMediumInfo(
          {
            medType: 'passwd',
            medTag: this.randomNum
          },
          { timeout: 45000 }
        )
        .then((data) => {
          data.procData(
            data.res,
            (data) => {
              if (data.medType === 'passwd' && data.medTag === this.randomNum) {
                this.passList = data.medValue.split(',')
                this.showInput = true
                this.randomNum = ''
                this.$message.success('读取成功')
              }
            },
            (err) => {
              this.$message.error(err)
            }
          )
        })
    },
    handleInput() {
      this.getMediumInfo()
    },
    handleDelete(data) {
      this.$confirm('是否确定删除选中的数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          fetch.delPassInfo({ id: data.id, person_id: this.data.id }).then((data) => {
            data.procData(
              data.res,
              () => {
                this.getInfo()
                this.$message.success('操作成功')
              },
              (err) => {
                this.$message.error(err)
              }
            )
          })
        })
        .catch(() => {})
    },
    confirmInput(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          fetch.addPassInfo({ ...this.manInfo, person_id: this.data.id }).then((data) => {
            data.procData(
              data.res,
              () => {
                this.getInfo()
                this.$message.success('操作成功')
                this.showInput = false
                this.$refs[formName].resetFields()
              },
              (err) => {
                this.$message.error(err)
              }
            )
          })
        } else {
          return false
        }
      })
    },
    cancelInput() {
      this.showInput = false
    },
    handleCancel() {
      this.$emit('handleClose')
    },
    getRandomNum() {
      let randomNum = new Date().getTime() + ''
      let tmpLen = randomNum.length
      let $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
      let maxPos = $chars.length
      for (var i = 0; i < 32 - tmpLen; i++) {
        randomNum += $chars.charAt(Math.floor(Math.random() * maxPos))
      }
      return randomNum
    }
  }
}
</script>

<style></style>
